routerConfig.$inject = [
  '$urlRouterProvider',
  '$stateProvider',
  'APP'


];

export default function routerConfig($urlRouterProvider, $stateProvider, APP) {
  // $urlRouterProvider.otcerwise('/');
  $stateProvider

    .state({
      name: 'order',
      parent: 'app',
      url: '/order',
      abstract: true,
      views: {
        'header@app': {
          template: '<header></header>'
        },
        'sidenav@app': {
          template: '<sidenav></sidenav>'
        }
      },
      resolve: {
        isAuthenticated: ['authService', '$stateParams', function (authService) {
          return authService.isAuthenticated();
        }]
      }
    })

    .state({
      name: 'cart',
      parent: 'order',
      url: '/cart',
      views: {
        'content@app': {
          template: '<cart></cart>'
        }
      }
    })
    .state({
      name: 'guestcart',
      parent: 'order',
      url: '/guestcart',
      views: {
        'content@app': {
          template: '<guestcart></guestcart>'
        }
      }
    })
    .state({
      name: 'guestdelivery',
      parent: 'order',
      url: '/guestdelivery',
      views: {
        'content@app': {
          template: '<guestdelivery></guestdelivery>'
        }
      }
    })
    .state({
      name: 'accessibility',
      parent: 'order',
      url: '/accessibility',
      views: {
        'content@app': {
          template: '<accessibility></accessibility>'
        }
      }
    })
    .state({
      name: 'savings-club',
      parent: 'order',
      url: '/daily-savings-club/:storeName',
      views: {
        'content@app': {
          template: '<savings-club></savings-club>'
        }
      },
      resolve: {
        isAuthenticated: ['authService', '$stateParams', '$timeout', function (authService, $stateParams, $timeout) {
          $timeout(() => {
            if ($stateParams.storeName && $stateParams.storeName != APP.ORDER_URL.browseUrl && !authService.isLoggedIn()) {
              authService.getStoreDetail($stateParams.storeName).then(success => {
                let store = {};
                store.storeId = success.data.storeId;
                store.storeName = $stateParams.storeName;
                authService.doGuestLogin(store);
                return authService.isAuthenticated();
              },
                error => {
                  if (error) {
                    return authService.isAuthenticated();
                  }
                }
              );

            }
            else {
              return authService.isAuthenticated();
            }
          });
        }]
      }
    })
    .state({
      name: 'gift-card',
      parent: 'order',
      url: '/gift-card/:storeName',
      views: {
        'content@app': {
          template: '<gift-card></gift-card>'
        }
      },
      resolve: {
        isAuthenticated: ['authService', '$stateParams', '$timeout', function (authService, $stateParams, $timeout) {
          $timeout(() => {
            if ($stateParams.storeName && $stateParams.storeName != APP.ORDER_URL.browseUrl && !authService.isLoggedIn()) {
              authService.getStoreDetail($stateParams.storeName).then(success => {
                let store = {};
                store.storeId = success.data.storeId;
                store.storeName = $stateParams.storeName;
                authService.doGuestLogin(store);
                return authService.isAuthenticated();
              },
                error => {
                  if (error) {
                    return authService.isAuthenticated();
                  }
                }
              );

            }
            else {
              return true;
            }
          });
        }]
      }
    })
    .state({
      name: 'search',
      parent: 'order',
      url: '/search/:storeName?searchTerm',
      views: {
        'content@app': {
          template: '<search></search>'
        }
      }
    })
    // .state({
    //   name: 'browse',
    //   parent: 'app',
    //   url: '/browse/:categoryName',
    //   controller :'category',
    //   views: {
    //     'header@app': {
    //       template: '<header></header>'
    //     },
    //     'sidenav@app': {
    //       template: '<sidenav></sidenav>'
    //     },
    //     'content@app': {
    //       template: '<category></category>'
    //     }
    //   },
    //   data: {
    //     meta: {
    //       'title': 'Category Page',
    //       'description': 'Category Page Description',
    //       'url':'Category  Url',
    //       'type':'Category Type',
    //       'image':'Category Image',
    //       'alt':'Category Alt'

    //     }
    //   },
    //   resolve: {
    //     isAuthenticated: ['authService', '$stateParams', '$timeout', function(authService, $stateParams, $timeout) {
    //       $timeout(() => {
    //         if (!authService.isLoggedIn()) {
    //           let storeName = $stateParams.storeName;
    //           let categoryName = $stateParams.categoryName;
    //           if(storeName && storeName!='') {
    //           authService.getStoreDetail(storeName).then(success => {
    //             let store = {};
    //             store.storeId = success.data.storeId;
    //             store.storeName = storeName;
    //             authService.doGuestLogin(store);
    //             return authService.isAuthenticated();
    //           },
    //         error => {
    //           if (error) {
    //             return authService.isAuthenticated();
    //           }
    //         }
    //       ); }
    //       else {
    //         let store = {};
    //         store.storeId = '';
    //         store.storeName = '';
    //         authService.doGuestLogin(store);
    //         return authService.isAuthenticated();
    //       }

    //         }
    //         else {
    //           return authService.isAuthenticated();
    //         }
    //       });
    //     }]
    //   }
    // })
    .state({
      name: 'category',
      parent: 'app',
      url: '/:storeName',
      controller: 'category',
      views: {
        'header@app': {
          template: '<header></header>'
        },
        'sidenav@app': {
          template: '<sidenav></sidenav>'
        },
        'content@app': {
          template: '<category></category>'
        }
      },
      data: {
        meta: {
          'title': 'Category Page',
          'description': 'Category Page Description',
          'url': 'Category  Url',
          'type': 'Category Type',
          'image': 'Category Image',
          'alt': 'Category Alt'

        }
      },
      resolve: {
        isAuthenticated: ['authService', '$stateParams', '$timeout', function (authService, $stateParams, $timeout) {
          $timeout(() => {
            if ($stateParams.storeName == APP.ORDER_URL.browseUrl && $stateParams.subCategoryId != undefined && !$stateParams.subCategoryId) {

              // let value = authService.isBrowseUrl();
              return false;
            }
            if (!authService.isLoggedIn()) {
              let storeName = '';
              if ($stateParams.storeName) {
                storeName = $stateParams.storeName;
              }
              else {
                if (this.profile && this.profile.store && this.profile.store.storeName) {
                  storeName = this.profile.store.storeURLName;
                } else {
                  storeName = authService.getGuestStoreDetail().storeName;
                }
              }
              if (storeName && storeName != '') {
                authService.getStoreDetail(storeName).then(success => {
                  let store = {};
                  store.storeId = success.data.storeId;
                  store.storeName = storeName;
                  authService.doGuestLogin(store);
                  return authService.isAuthenticated();
                },
                  error => {
                    if (error) {
                      return authService.isAuthenticated();
                    }
                  }
                );
              }
              else {
                // let store = {};
                // store.storeId = '';
                // store.storeName = '';
                // authService.doGuestLogin(store);
                return authService.isAuthenticated();
              }

            }
            else {
              return authService.isAuthenticated();
            }
          });
        }]
      }
    })
    .state({
      name: 'browse-sub-category',
      parent: 'app',
      url: '/:storeName/:categoryId',
      controller: 'sub-category',
      views: {
        'header@app': {
          template: '<header></header>'
        },
        'sidenav@app': {
          template: '<sidenav></sidenav>'
        },
        'content@app': {
          template: '<sub-category></sub-category>'
        }
      },
      data: {
        meta: {
          'title': 'subCategory Page',
          'description': 'subCategory Page Description /:categoryId',
          'url': 'subCategory  Url',
          'type': 'subCategory Type',
          'image': 'subCategory Image',
          'alt': 'subCategory Alt'

        }
      },
      resolve: {
        isAuthenticated: ['authService', '$stateParams', '$timeout', function (authService, $stateParams, $timeout) {
          $timeout(() => {

            if (!authService.isLoggedIn()) {
              let storeName = '';
              if ($stateParams.storeName) {
                if (!'shop' === $stateParams.storeName) {
                  storeName = $stateParams.storeName;
                }
              }
              else {

                if (this.profile && this.profile.store && this.profile.store.storeName) {
                  storeName = this.profile.store;
                } else {
                  storeName = authService.getGuestStoreDetail().storeName;
                }

              }
              if (storeName && storeName != '') {
                authService.getStoreDetail(storeName).then(success => {
                  let store = {};
                  store.storeId = success.data.storeId;
                  store.storeName = storeName;
                  authService.doGuestLogin(store);
                  return authService.isAuthenticated();
                },
                  error => {
                    if (error) {
                      return authService.isAuthenticated();
                    }
                  }
                );
              }
              else {
                // let store = {};
                // store.storeId = '';
                // store.storeName = '';
                // authService.doGuestLogin(store);
                return authService.isAuthenticated();
              }

            }
            else {
              return authService.isAuthenticated();
            }
          });
        }]
      }
    })
    /* .state({
      name: 'sub-category',
      parent: 'category',
      url: '/:categoryId',
      controller :'sub-category',
      views: {
        'content@app': {
          template: '<sub-category></sub-category>'
        }
      },
      data: {
        meta: {
          'title': 'subCategory Page',
          'description': 'subCategory Page Description /:categoryId',
          'url':'subCategory  Url',
          'type':'subCategory Type',
          'image':'subCategory Image',
          'alt':'subCategory Alt'

        }
      }
    })*/
    .state({
      name: 'browse-product',
      parent: 'browse-sub-category',
      url: '/:subCategoryId',
      views: {
        'content@app': {
          template: '<product></product>'
        }
      }
    })
    /* .state({
       name: 'product',
       parent: 'browse-sub-category',
       url: '/:subCategoryId',
       views: {
         'content@app': {
           template: '<product></product>'
         }
       }
     })*/
    /*  .state({
        name: 'product.detail',
        url: '/:productId',
        controller:'productDetail',
        params: {
          forSubscription: false
        },
        views: {
          'content@app': {
            template: '<product-detail></product-detail>'
          }
        },
        data: {
          meta: {
            'title': 'Product Page',
            'description': 'Product Page Description /:categoryId',
            'url':'URL',
            'type':'website',
            'image':'Product Image',
            'alt':'Product Alt'
        
          }
        }
  
      })*/
    .state({
      name: 'browse-product.detail2',
      url: '/:productId',


      controller: 'productDetail',
      params: {
        forSubscription: false
      },
      views: {
        'content@app': {
          template: '<product-detail></product-detail>'
        }
      },
      data: {
        meta: {
          'title': 'Product Page',
          'description': 'Product Page Description /:categoryId',
          'url': 'URL',
          'type': 'website',
          'image': 'Product Image',
          'alt': 'Product Alt'

        }
      }
    })
    .state({
      name: 'browse-product.detail',
      url: '/:productId/:itemGroupNumber',
      controller: 'productDetail',
      params: {
        forSubscription: false
      },
      views: {
        'content@app': {
          template: '<product-detail></product-detail>'
        }
      },
      data: {
        meta: {
          'title': 'Product Page',
          'description': 'Product Page Description /:categoryId',
          'url': 'URL',
          'type': 'website',
          'image': 'Product Image',
          'alt': 'Product Alt'

        }
      }

    })
    .state({
      name: 'browse-product.detail1',
      url: '/:productId/reminder/:reminderId',
      controller: 'productDetail',
      params: {
        forSubscription: false
      },
      views: {
        'content@app': {
          template: '<product-detail></product-detail>'
        }
      },
      data: {
        meta: {
          'title': 'Product Page',
          'description': 'Product Page Description /:categoryId',
          'url': 'URL',
          'type': 'website',
          'image': 'Product Image',
          'alt': 'Product Alt'

        }
      }

    })
    .state({
      name: 'browse-product.review',
      url: '/:productId/write-a-review',
      controller: 'productReview',
      views: {
        'content@app': {
          template: '<product-review></product-review>'
        }
      }
    })
    .state({
      name: 'browse-product.review1',
      url: '/:productId/:itemGroupNumber/write-a-review',
      controller: 'productReview',
      views: {
        'content@app': {
          template: '<product-review></product-review>'
        }
      }
    })
    // .state({
    //   name: 'product.review',
    //   parent: 'browse-sub-category',
    //   url: '/write-a-review',
    //   controller: 'product-review',
    //   views: {
    //     'content@app': {
    //       template: '<product-review></product-review>'
    //     }
    //   }
    // })
    .state({
      name: 'store-detail',
      parent: 'order',
      url: '/store-detail',
      views: {
        'content@app': {
          template: '<store-detail></store-detail>'
        }
      }
    })
    .state({
      name: 'storelocator',
      parent: 'order',
      url: '/store-locator',
      views: {
        'content@app': {
          template: '<storelocator></storelocator>'
        }
      }
    })

    .state({
      name: 'delivery',
      parent: 'order',
      url: '/delivery',
      views: {
        'content@app': {
          template: '<delivery></delivery>'
        }
      }
    })
    .state({
      name: 'delivery.address',
      url: '/address',
      views: {
        'content@app': {
          template: '<delivery-address></delivery-address>'
        }
      }
    })

    .state({
      name: 'payment',
      parent: 'order',
      url: '/:orderId/payment',
      params: { isCardSaved: null },
      abstract: true
    })
    .state({
      name: 'card-detail',
      parent: 'payment',
      url: '/card-detail',
      views: {
        'content@app': {
          template: '<card-detail></card-detail>'
        }
      }
    })
    .state({
      name: 'payment.success',
      url: '/success',
      views: {
        'content@app': {
          template: '<payment-success></payment-success>'
        }
      }
    })
    .state({
      name: 'payment.failure',
      url: '/failure?reasonCode',
      params: {logString: null},
      views: {
        'content@app': {
          template: '<payment-failure></payment-failure>'
        }
      }
    })
    .state({
      name: 'payment.summary',
      url: '/summary-failure',
      views: {
        'content@app': {
          template: '<summary-failure></summary-failure>'
        }
      }
    })
    .state({
      name: 'recent-order',
      parent: 'order',
      url: '/recent-order',
      views: {
        'content@app': {
          template: '<recent-order></recent-order>'
        }
      }
    })
    .state({
      name: 'subscription',
      parent: 'order',
      url: '/subscription',
      views: {
        'content@app': {
          template: '<subscription></subscription>'
        }
      }
    }).state({
      name: 'subscribable-products',
      parent: 'subscription',
      url: '/subscribable-products',
      views: {
        'content@app': {
          template: '<subscription-products></subscription-products>'
        }
      }
    })
    .state({
      name: 'detail',
      parent: 'subscribable-products',
      url: '/:subsProductId/detail',
      views: {
        'content@app': {
          template: '<Products-detail></Products-detail>'
        }
      }
    })
    .state({
      name: 'subscription-detail',
      parent: 'subscription',
      url: '/:subscriptionId/subscription-detail/:option',
      views: {
        'content@app': {
          template: '<subscription-detail></subscription-detail>'
        }
      }
    })
    .state({
      name: 'subscription-success',
      parent: 'subscription-detail',
      url: '/success',
      views: {
        'content@app': {
          template: '<subscription-success></subscription-success>'
        }
      }
    })
    .state({
      name: 'store-redirect',
      url: '/store/:storeName',
      controller: ['$scope', '$stateParams', '$state', function ($scope, $stateParams, $state) {
        console.log("Indirect Routing to store : ", $stateParams.storeName);
        $state.go('category', { 'storeName': $stateParams.storeName });
      }]
    })
    .state({
      name: 'payment-detail',
      params: { giftcardReq: null, storeCreditAmountToBeCharged: 0.00 },
      parent: 'payment',
      url: '/payment',
      views: {
        'content@app': {
          template: '<payment-detail></payment-detail>'
        }
      }
    })
    .state({
      name: 'tsys-payment',
      params: { giftcardReq: null, storeCreditAmountToBeCharged: 0.00 },
      parent: 'payment',
      url: '/tsys',
      views: {
        'content@app': {
          template: '<tsys-payment></tsys-payment>'
        }
      }
    })
    .state({
      name: 'moneris-payment',
      params: { giftcardReq: null, storeCreditAmountToBeCharged: 0.00 },
      parent: 'payment',
      url: '/moneris',
      views: {
        'content@app': {
          template: '<moneris-payment></moneris-payment>'
        }
      }
    })
    .state({
      name: 'card-update',
      parent: 'cards-management',
      url: '/card/:cardId',
      views: {
        'content@app': {
          template: '<card-update></card-update>'
        }
      }
    })
    .state({
      name: 'tsyscard-update',
      parent: 'cards-management',
      url: '/tsys/card/:cardId',
      views: {
        'content@app': {
          template: '<tsyscard-update></tsyscard-update>'
        }
      }
    });
}



// WEBPACK FOOTER //
// ./src/app/order/router.js